<template>
    <page>
        <!-- 表单区 -->
        <template slot="secondHeader">
            <el-form
                ref="queryForm"
                class="second-header npa-b"
                size="small"
                :inline="true"
                :model="queryFormModel"
            >
                <el-form-item
                    prop="moduleCode"
                    label="模块代码"
                >
                    <el-input
                        v-model="queryFormModel.moduleCode"
                        placeholder="请输入模块代码"
                    />
                </el-form-item>
                <el-form-item
                    prop="moduleName"
                    label="模块名称"
                >
                    <el-input
                        v-model="queryFormModel.moduleName"
                        placeholder="请输入模块名称"
                    />
                </el-form-item>
                <el-form-item
                    prop="availableLanguage"
                    label="可用语言"
                >
                    <dictionaries-picker
                        type="language"
                        v-model="queryFormModel.availableLanguage"
                    />
                </el-form-item>
                <el-form-item>
                    <el-button
                        type="primary"
                        @click="onQuery()"
                    >
                        查询
                    </el-button>
                    <el-button
                        type="success"
                        @click="onReset"
                    >
                        重置
                    </el-button>
                </el-form-item>
            </el-form>
        </template>

        <!-- 内容 -->
        <div
            class="body"
            slot="body"
            v-loading="querying"
        >
            <!-- 操作 -->
            <div
                class="ma-b"
            >
                <el-button-group>
                    <el-button
                        type="success"
                        icon="el-icon-plus"
                        size="small"
                        @click="onAdd"
                    >
                        新增
                    </el-button>
                    <el-button
                        type="danger"
                        icon="el-icon-delete"
                        size="small"
                        @click="onDelete"
                        :disabled="!currentTableSelect.length"
                    >
                        删除
                    </el-button>
                </el-button-group>
            </div>

            <!-- 表格 -->
            <el-table
                stripe
                border
                size="small"
                :data="tableData"
                style="width: 100%"
                @selection-change="onTableSelectionChange"
            >
                <el-table-column
                    type="selection"
                    width="39"
                />
                <el-table-column
                    prop="moduleCode"
                    label="模块代码"
                    min-width="120"
                />
                <el-table-column
                    prop="moduleName"
                    label="模块名称"
                    min-width="120"
                />
                <el-table-column
                    prop="availableLanguageName"
                    label="可用语言"
                    min-width="100"
                />
                <el-table-column
                    prop="defaultLanguageName"
                    label="默认语言"
                    width="120"
                />
                <el-table-column
                    prop="moduleDesc"
                    label="模块描述"
                    min-width="150"
                />
                <el-table-column
                    fixed="right"
                    label="操作"
                    width="120"
                >
                    <template slot-scope="scope">
                        <el-button
                            type="text"
                            size="small"
                            @click="onTableEdit(scope.row)"
                        >
                            编辑
                        </el-button>
                        <el-button
                            type="text"
                            size="small"
                            @click="onTableDelete(scope.row.id)"
                        >
                            删除
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>

            <!-- 分页 -->
            <div class="ma-t ta-r">
                <pagination
                    v-model="pagination"
                    @input="onQuery"
                />
            </div>
        </div>


        <!-- 弹框 -->
        <!-- 新增/编辑 -->
        <el-dialog
            :title="addDialog.formModel.id ? '编辑' : '新增'"
            center
            width="600px"
            :visible.sync="addDialog.isVisible"
            @closed="onAddDialogCancel"
        >
            <el-form
                ref="addForm"
                size="small"
                :model="addDialog.formModel"
                :rules="addDialog.formRules"
            >
                <el-form-item
                    prop="moduleName"
                    label="模块名称"
                    label-width="6em"
                >
                    <el-input
                        v-model="addDialog.formModel.moduleName"
                        auto-complete="off"
                    />
                </el-form-item>
                <el-form-item
                    prop="moduleCode"
                    label="模块代码"
                    label-width="6em"
                >
                    <el-input
                        v-model="addDialog.formModel.moduleCode"
                        auto-complete="off"
                    />
                </el-form-item>
                <el-form-item
                    prop="availableLanguage"
                    label="可用语言"
                    label-width="6em"
                >
                    <checkbox-group-andOr
                        type="language"
                        v-model="addDialog.formModel.availableLanguage"
                    />
                </el-form-item>
                <el-form-item
                    prop="defaultLanguage"
                    label="默认语言"
                    label-width="6em"
                >
                    <dictionaries-picker
                        type="language"
                        v-model="addDialog.formModel.defaultLanguage"
                    />
                </el-form-item>
                <el-form-item
                    prop="moduleDesc"
                    label="模块描述"
                    label-width="6em"
                >
                    <el-input
                        type="textarea"
                        v-model="addDialog.formModel.moduleDesc"
                    />
                </el-form-item>
            </el-form>
            <div
                slot="footer"
                class="dialog-footer"
            >
                <el-button
                    type="primary"
                    size="small"
                    @click="onAddDialogConfirm"
                >
                    确 定
                </el-button>
                <el-button
                    size="small"
                    @click="onAddDialogCancel"
                >
                    取 消
                </el-button>
            </div>
        </el-dialog>
    </page>
</template>

<script>
import pagesMixin from '@/mixin/layout/pageMixin';
import { queryFormList } from 'vmf/src/mixins';

export default {
    name: 'LanguageModule',
    mixins: [pagesMixin, queryFormList],
    data() {
        return {
            queryFormModel: {
                moduleMode: '',
                moduleName: '',
                availableLanguage: '',
            },
            // 新增/编辑
            addDialog: {
                // 对话框显示
                isVisible: false,
                // 表单数据
                formModel: {
                    id: '',
                    moduleName: '',
                    moduleCode: '',
                    availableLanguage: '',
                    defaultLanguage: '',
                    moduleDesc: '',
                },
                // 表单校验规则
                formRules: {
                    moduleName: {
                        required: true,
                        message: '请输入模块名称',
                        trigger: 'blur',
                    },
                    moduleCode: {
                        required: true,
                        message: '请输入模块代码',
                        trigger: 'blur',
                    },
                    availableLanguage: {
                        required: true,
                        message: '请选择可用语言',
                    },
                    defaultLanguage: {
                        required: true,
                        message: '请选择默认语言',
                    },
                },
            },
            // 表格数据
            tableData: [],
            // 表格当前选中行
            currentTableSelect: [],
        };
    },
    methods: {
        /* -- 方法 -- */
        // 请求列表数据
        getListData(queryData) {
            return this.$api.Rs.LanguageModule.data(queryData).then(json => {
                const res = json.data;
                this.tableData = res.data;
                this.pagination = res.pagination;
                return Promise.resolve(json);
            });
        },
        onTableSelectionChange(val) {
            this.currentTableSelect = val;
        },
        onTableDelete(ids) {
            this.$confirm('是否确定要删除！', '温馨提示', {
                type: 'warning',
            }).then(() => {
                this.$api.Rs.LanguageModule.delete({ ids }).then(json => {
                    const res = json.data;
                    this.$message({
                        message: res.msg,
                        type: 'success',
                    });
                    this.onQuery(this.pagination);
                });
            });
        },
        onDelete() {
            const ids = this.currentTableSelect.reduce((prev, next) => {
                prev.push(next.id);
                return prev;
            }, []);
            this.onTableDelete(ids.join(','));
        },
        onAdd() {
            this.addDialog.isVisible = true;
            this.$nextTick(() => {
                const { addForm } = this.$refs;
                addForm.resetFields();
                const { formModel } = this.addDialog;
                formModel.id = '';
            });
        },
        onTableEdit(row) {
            const { formModel } = this.addDialog;
            this.$api.Rs.LanguageModule.getDetail({ id: row.id }).then(json => {
                const res = json.data.data;
                this.$utils.formModelMerge(formModel, res);
            });
            this.addDialog.isVisible = true;
        },
        onAddDialogConfirm() {
            const { addForm } = this.$refs;
            addForm.validate().then(() => {
                this.$api.Rs.LanguageModule.save({
                    ...this.addDialog.formModel,
                }).then(json => {
                    const res = json.data;
                    this.$message({
                        message: res.msg,
                        type: 'success',
                    });
                    this.onQuery(this.pagination);
                    this.addDialog.isVisible = false;
                });
            });
        },
        onAddDialogCancel() {
            const { addForm } = this.$refs;
            addForm.resetFields();
            const { formModel } = this.addDialog;
            formModel.id = '';
            this.addDialog.isVisible = false;
        },
    },
};
</script>

<style lang="scss">
</style>
